import React, { Component } from 'react';
import { Table, message, Spin } from 'antd';
import { TRANSACTIONS_URL } from "../../../utils/config"
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { POOL_DATA } from "../../../utils/config";

import './Transaction.css';

class Transaction extends Component {

  state = {
    dataSource: [],
    display: 'none',
    loading: true,
  };

  flattenArray = (arr) => {
    let result = [];
    let _flattenArray = function(arr) {
      let i, len;
      for(i = 0, len = arr.length; i < len; ++i) {
        if(Array.isArray(arr[i])) {
          _flattenArray(arr[i]);
        } else {
          result.push(arr[i]);
        }
      }
    };
    _flattenArray(arr);
    return result;
  };

  componentDidMount() {
      const userPool = new CognitoUserPool(POOL_DATA);
      const cognitoUser = userPool.getCurrentUser();

      if (cognitoUser !== null) {
          cognitoUser.getSession((err, session) => {
              if (err) {
                  message.error('The session has expired, please login again');
                  this.props.history.push('/login');
                  return;
              }
              if (session.isValid() === true) {
                  this.setState({
                      loading: true,
                  });

                  var userid = cognitoUser.getUsername();
                  //document.write(userid);

                  const transactionsURL = `${TRANSACTIONS_URL}?userid=${userid}`;
                  fetch(transactionsURL, {
                      method: 'GET',
                  })
                      .then(res => res.json())
                      .then((data) => {
                          this.setState({
                              loading: false,
                          });
                          const keys=[];
                          const values=[];
                          for(let key in data){
                              keys.push(key);
                              values.push(data[key]);//取得value
                          }
                          this.setState({
                              dataSource: this.flattenArray(values).map((item, index) => {
                                  item.key = index;
                                  return item;
                              }),
                          });
                          if (this.state.dataSource.length > 10 ) {
                              this.setState({
                                  display: 'block',
                              });
                          }
                      })
                      .catch((err) => {
                          message.error(String(err));
                      });

              } else {
                  message.error('The session has expired, please login again');
                  this.props.history.push('/login');
              }
          })
      } else {
          message.error('The session has expired, please login again');
          this.props.history.push('/login');
      }
  };

  render() {
   const columns = [
       {title: 'Date',
            dataIndex: 'createTime',
            key: 'date',
            render: text => <span style={{ fontSize: '14px', color: 'rgba(0,0,0,0.5)' }}>{text}</span>
       }, {title: 'Store',
           dataIndex: 'store',
           key: 'store',
           render: text => <span style={{ fontSize: '14px', fontWeight: 700 }}>{text}</span>
       }, {title: 'Product Name',
           dataIndex: 'productName',
           key: 'name',
           render: text => <span style={{ fontSize: '14px', fontWeight: 700 }}>{text}</span>
       },{title: 'Price',
           dataIndex: 'productPrice',
           key: 'price',
           render: text => <span style={{ fontSize: '14px', color: '#BD2905' }}>$ {text}</span>
       }, {title: 'Cashback',
           dataIndex: 'cashback',
           key: 'earned',
           render: text => <span style={{ fontSize: '14px', color: '#BD2905' }}>$ {text}</span>
   }];

    return (
      <div className="Transaction">
        <h2>Transactions history</h2>
        <span className="Tips">Only 10 latest transaction was posted here, please see more transaction in Apps</span>
        <Spin spinning={this.state.loading}>
          <Table columns={columns} dataSource={this.state.dataSource}/>
        </Spin>
      </div>
    )
  }
}

export default Transaction;



// WEBPACK FOOTER //
// ./src/Containers/Profile/components/Transaction.js